import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
const messages = {
  en: {
    message: {
      PreRegister: "Pre Register",
      TerminalStamp: "Terminal Stamp",
      ParkingRedemption: "Parking Redemption",
      ManagePreRegister: "Manage Pre Register",
      Redemption: "Redemption",
      Search: "Search",
      ScanQRCode: "Scan QRCode",
      PleaseInput: "Please Input",
      InputPlaceholder: "License No./Ticket No./Log Id.",
      ParkingInformation: "Parking Information",
      TicketNo: "Ticket No.",
      DateTime: "Date",
      DateTimeIn: "DateTimeIn",
      TimeIn: "Time In",
      Duration: "Duration",
      exempt: "Exempt",
      summaryDuration: "Summary Duration",
      CarLicense: "License Plate",
      VehicleName: "Vehicle Name",
      RateCode: "RateCode",
      RateDetail: "Rate Detail",
      Total: "Total",
      SpendingValue: "Spending Value",
      POSValue: "POS Value",
      Scanner: "Scanner",
      ClearRate: "Clear Rate Detail",
      Remark: "Remark",
      EStamp: "E-Stamp",
      Cancel: "Cancel",
      RedemptionSuccess: "Redemption Success !",
      Back: "Back",
      Submit: "Submit",
      TotalAmount: "Total",
      Add: "Add",
      Create: "Create",
      Baht: "Baht",
      CouponValue: "Coupon",
      Hour: "Hour",
      TotalCoupon: "Total Coupon",
      POSValueOrCoupon: "POS/Coupon",
      UsageTiger: "Usage Tiger Retail Shop",
      UsageCoupon: "Rabbit Rewards Coupon",
      NormalServiceRate: "Rate Detail",
      PromotionDiscount: "Promotion Discount",
      ReceiptFromPurchase: "Receipt From Purchase",
      TotalPromotionDiscount: "Total Promotion Discount",
      RateDetailLang: "ENG",
      Close: "Close",
      VehicleType: "VehicleType",
      Next: "Next",
      Car: "Car",
      Motorcycle: "Motorcycle",
      No: "No.",
      StartDate: "Start Date",
      EndDate: "End Date",
      StartTime: "Start Time",
      EndTime: "End Time",
      PreRegisterParking: "Pre Register",
      WalkIn: "Walk In",
      MyQR: "My QR",
      PreRegisterParkingMenu: "Parking Pre Register",
      WorkPermitNumber: "Work Permit No",
      FirstName: "First Name",
      LastName: "Last Name",
      PhoneNumber: "Phone",
      Email: "Email",
      LicensePlate: "License Plate",
      Province: "Province",
      VisitorSummary: "Visitor Summary",
      FullName: "Name",
      OfficerApprove: "Officer Approve",
      SelectApproverEmail: "Select Approver Email",
      ParkingWalkIn: "Parking Walk In",
      GetThaiID: "Get Thai ID",
      GetPassport: "Get Passport",
      PreRegisterDetail: "Pre Register Detail",
      CreateTime: "Create Time",
      Approved: "Approved",
      NotApproved: "Not Approved",
      Active: "Active",
      InActive: "In Active",
      Status: "Status",
      Action: "Action",
      VisitorType: "Visitor Type",
      StatusApprove: "Approve",
      WalkInName: "Walk In",
      JorporPlus: "JorporPlus",
      SelfPreRegister: "Self PreRegister",
      Expired: "Expired",
      Rejected: "Rejected",
      UserManagement: "User Management",
      Username: "Username",
      RoleName: "Rolename",
      ManageUser: "Manage User",
      Password: "Password",
      Role: "Role",
      SectionName: "Section",
      Update: "Update",
      ManageRole: "Manage Role",
      RoleID: "Role ID",
      Permission: "Permission",
      ManageSection: "Manage Section",
      BlackListVisitor: "BlackList Visitor",
      SectionNameTH: "SectionName",
      SectionNameENG: "SectionName ENG",
      SectionID: "SectionID",
      Approver: "Approver",
      Subordinates: "Subordinates (Users)",
      Users: "Users",
      ChangePassword: "Change Password",
      OldPassword: "Old Password",
      NewPassword: "New Password",
      ConfirmNewPassword: "Confirm Password",
      Logout: "Logout",
      BlackList: "BlackList Visitor",
      BlacklistID: "Blacklist ID",
      InviteTenantName: "Invite Tenant Name",
      InviteLocationName: "Invite Location Name",
      GuestInviteName: "Guest Invite Name",
      ViewPreRegister: "View Pre Register",
      GuestInformation: "Guest Information",
      InviteNo: "Invite No.",
      InviteName: "Invite Name",
      Location: "Location",
      Tenant: "Tenant",
      VisitDuration: "Visit Duration",
      WantToReject: "Do you want to reject this pre-register ?",
      Reject: "Reject",
      Information: "Information",
      RedemptionHistory: "Redemption History",
      BackToMain: "Back to main",
      SelectFloor: "Select Floor",
      SyncMemberFineday: "Sync Member Fineday",
      MemberID: "Member ID",
      Telephone: "Telephone",
      RedemptionSettings: "Redemption Settings",
      Department: "Department",
      RedemptionType: "Redemption Type",
      UserLevel: "User Level",
      UpdateTime: "Update Time",
    },
  },
  th: {
    message: {
      PreRegister: "ลงทะเบียนเข้าอาคารล่วงหน้า",
      TerminalStamp: "จุดบริการทำส่วนลดค่าจอดรถ",
      ParkingRedemption: "ส่วนลดค่าบริการที่จอดรถ",
      Redemption: "ประทับตราส่วนลดค่าจอดรถ",
      ManagePreRegister: "จัดการลงทะเบียนเข้าอาคารล่วงหน้า",
      Search: "ค้นหา",
      ScanQRCode: "สแกนคิวอาร์โค้ด",
      PleaseInput: "กรุณากรอก",
      InputPlaceholder: "ทะเบียนรถ/เลขบัตรจอดรถ/รหัสรายการ",
      ParkingInformation: "รายละเอียดการจอดรถ",
      TicketNo: "เลขบัตรจอดรถ",
      DateTime: "วันที่",
      DateTimeIn: "วันที่เข้า",
      TimeIn: "เวลาเข้า",
      Duration: "ระยะเวลาจอดรถ",
      exempt: "ได้รับยกเว้น",
      summaryDuration: "เวลาสุทธิ",
      CarLicense: "ทะเบียนรถ",
      VehicleName: "ประเภทยานพาหนะ",
      RateCode: "รหัสตราประทับ",
      RateDetail: "รายละเอียดเงื่อนไข",
      Total: "ค่าจอดรถ",
      SpendingValue: "ยอดค่าใช้จ่าย",
      POSValue: "ยอดใบเสร็จ POS",
      Scanner: "เครื่องสแกน",
      ClearRate: "เคลียร์เงื่อนไข",
      Remark: "หมายเหตุ",
      EStamp: "ประทับตรา",
      Redeem: "ไถ่ถอน",
      Cancel: "ยกเลิก",
      RedemptionSuccess: "ประทับตราส่วนลดสำเร็จ",
      Back: "ย้อนกลับ",
      Submit: "ตกลง",
      TotalAmount: "รวมทั้งสิ้น",
      Add: "เพิ่มข้อมูล",
      Create: "เพิ่มข้อมูล",
      Baht: "บาท",
      CouponValue: "ยอดคูปอง",
      Hour: "ชั่วโมง",
      TotalCoupon: "รวมคูปอง",
      POSValueOrCoupon: "ยอดใบเสร็จ POS/คูปอง",
      UsageTiger: "ใช้บริการร้านค้า Tiger",
      UsageCoupon: "คูปอง Rabbit Rewards",
      NormalServiceRate: "อัตราค่าบริการปกติ",
      PromotionDiscount: "ส่วนลดจากโปรโมชัน",
      ReceiptFromPurchase: "ใบเสร็จจากการซื้อสินค้า",
      TotalPromotionDiscount: "รวมส่วนลดโปรโมชัน",
      RateDetailLang: "TH",
      Close: "ปิด",
      VehicleType: "กรุณาเลือกประเภทรถ",
      Next: "ต่อไป",
      Car: "รถยนต์",
      Motorcycle: "รถจักรยานยนต์",
      No: "ลำดับที่",
      StartDate: "วันที่เริ่มต้น",
      EndDate: "วันที่สิ้นสุด",
      StartTime: "เวลาเริ่มต้น",
      EndTime: "เวลาสิ้นสุด",
      PreRegisterParking: "ลงทะเบียนจอดรถล่วงหน้า",
      WalkIn: "ลงทะเบียนผู้มาติดต่อ",
      MyQR: "คิวอาร์โค้ดของฉัน",
      PreRegisterParkingMenu: "ลงทะเบียนจอดรถล่วงหน้า",
      WorkPermitNumber: "หมายเลขใบอนุญาตทำงาน",
      FirstName: "ชื่อ",
      LastName: "นามสกุล",
      PhoneNumber: "เบอร์โทรศัพท์",
      Email: "อีเมล",
      LicensePlate: "หมายเลขทะเบียนรถ",
      Province: "จังหวัด",
      VisitorSummary: "สรุปข้อมูลผู้มาติดต่อ",
      FullName: "ชื่อ-นามสกุล",
      OfficerApprove: "เจ้าหน้าที่อนุมัติ",
      SelectApproverEmail: "เลือกอีเมลผู้อนุมัติ",
      ParkingWalkIn: "ลงทะเบียนจอดรถสำหรับผู้มาติดต่อหน้างาน",
      GetThaiID: "บัตรประชาชน",
      GetPassport: "หนังสือเดินทาง",
      PreRegisterDetail: "รายละเอียดการลงทะเบียน",
      CreateTime: "วันเวลาที่สร้าง",
      Approved: "ได้รับการอนุมัติ",
      NotApproved: "ไม่ได้รับการอนุมัติ",
      Active: "ใช้งาน",
      InActive: "ปิดใช้งาน",    
      Status: "สถานะ",
      Action: "จัดการ",
      VisitorType: "ประเภท",
      StatusApprove: "สถานะอนุมัติ",
      WalkInName: "ผู้มาติดต่อหน้างาน",
      JorporPlus: "จป. พลัส",
      SelfPreRegister: "ลงทะเบียนล่วงหน้าด้วยตัวเอง",
      Expired: "หมดอายุแล้ว",
      Rejected: "ถูกยกเลิก",
      UserManagement: "การจัดการบัญชีผู้ใช้",
      Username: "ชื่อบัญชี",
      RoleName: "สิทธิ์การใช้งาน",
      ManageUser: "จัดการบัญชีผู้ใช้",
      Password: "รหัสผ่าน",
      Role: "สิทธิ์การใช้งาน",
      SectionName: "แผนก",
      Update: "อัพเดท",
      ManageRole: "จัดการสิทธิ์การใช้งาน",
      RoleID: "รหัสสิทธิ์การใช้งาน",
      Permission: "สิทธิ์การใช้งาน",
      ManageSection: "การจัดการแผนก",
      BlackListVisitor: "การจัดการแบล็คลิสต์ผู้มาติดต่อ",
      SectionNameTH: "ชื่อแผนก",
      SectionNameENG: "ชื่อแผนกภาษาอังกฤษ",
      SectionID: "รหัสแผนก",
      Approver: "ผู้อนุมัติ",
      Subordinates: "ผู้ใช้งานที่อยู่ภายใต้การดูแล",
      Users: "ผู้ใช้งาน",
      ChangePassword: "เปลี่ยนรหัสผ่าน",
      OldPassword: "รหัสผ่านเดิม",
      NewPassword: "รหัสผ่านใหม่",
      ConfirmNewPassword: "ยืนยันรหัสผ่านใหม่",
      Logout: "ออกจากระบบ",
      BlackList: "แบล็คลิสต์ผู้มาติดต่อ",
      BlacklistID: "รหัสแบล็คลิสต์",
      InviteTenantName: "บริษัทที่มามาติดต่อ",
      InviteLocationName: "สถานที่ที่มาติดต่อ",
      GuestInviteName: "ชื่อผู้มาติดต่อ",
      ViewPreRegister: "ดูข้อมูลการลงทะเบียนล่วงหน้า",
      GuestInformation: "ข้อมูลผู้มาติดต่อ",
      InviteNo: "หมายเลขเชิญ",
      InviteName: "ชื่อผู้มาติดต่อ",
      Location: "สถานที่ที่มาติดต่อ",
      Tenant: "บริษัท",
      VisitDuration: "ระยะเวลาที่มาติดต่อ",
      WantToReject: "ต้องการยกเลิกการลงทะเบียนนี้หรือไม่ ?",
      Reject: "ยกเลิก",
      Information: "ข้อมูล",
      RedemptionHistory: "ประวัติการประทับตราส่วนลด",
      BackToMain: "กลับสู่หน้าหลัก",
      SelectFloor: "เลือกชั้น",
      SyncMemberFineday: "เชื่อมกับสมาชิกบน Fineday",
      MemberID: "รหัสสมาชิก",
      Telephone: "เบอร์โทรศัพท์",
      RedemptionSettings: "ตั้งค่าการประทับตราส่วนลด",
      Department: "แผนก",
      RedemptionType: "ประเภทการประทับตรา",
      UserLevel: "ระดับผู้ใช้",
      UpdateTime: "วันเวลาที่อัพเดท",
    },
  },
};
const i18n = new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  messages,
});

Vue.filter("myLocale", function (value) {
  return i18n.t(value);
});

export default i18n;
